import { GraphqlApiQuery } from "../../../../src/components/api-reference/doc-static-queries";
import APIReference from "../../../../src/components/api-reference";
import React from 'react';
export default {
  GraphqlApiQuery,
  APIReference,
  React
};